import {ComWixEcommerceCatalogSpiApiV1ItemTypeItemType, ItemTypeFragment} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class ItemTypeModel {
  public preset?: ItemTypePreset;
  public custom?: string;

  constructor(params: ItemTypeModel) {
    this.preset = params.preset;
    this.custom = params.custom;
  }

  public static fromCheckoutV1(itemType: ItemTypeFragment) {
    return new ItemTypeModel({
      preset: itemType.preset ? toItemTypePreset(itemType.preset) : undefined,
      custom: mapNullToUndefined(itemType.custom),
    });
  }
}

export enum ItemTypePreset {
  PHYSICAL = 'PHYSICAL',
  DIGITAL = 'DIGITAL',
  UNRECOGNISED = 'UNRECOGNISED',
  GIFT_CARD = 'GIFT_CARD',
  SERVICE = 'SERVICE',
}

const toItemTypePreset = (itemType: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType) => {
  switch (itemType) {
    case ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.PHYSICAL:
      return ItemTypePreset.PHYSICAL;
    case ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.DIGITAL:
      return ItemTypePreset.DIGITAL;
    case ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.SERVICE:
      return ItemTypePreset.SERVICE;
    case ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.UNRECOGNISED:
      return ItemTypePreset.UNRECOGNISED;
    case ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.GIFT_CARD:
      return ItemTypePreset.GIFT_CARD;
  }
};
